import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  header: {
    marginBottom: indent / 4,
  },
  timestampContainer: {
    marginBottom: indent * 1.5,
  },
  headerText: {
    color: black,
  },
  rankProgressCard: {
    marginBottom: 20,
    marginHorizontal: indent,
  },
  webSectionSpacing: {
    marginBottom: 12,
  },
  content: {
    backgroundColor: white,
    overflow: 'visible' as const,
  },
  loadingIndicator: {
    flex: 1,
    marginVertical: 60,
  },
});
